import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-es';
 
// Just pass your jquery instance and you're done
datepickerFactory($);
datepickerJAFactory($);
console.log("Entra al JS de agendar_cita")
$(document).ready(function () {
    var disponibilidad = false
    var correoRegex = RegExp(/^[a-zA-Z0-9._\-]+@[a-zA-Z0-9._\-]+\.[a-zA-Z0-9]{2,4}$/)
    $('#boton_agendar').prop('disabled',true)


    function limpiar_select_horario(){
        var sel = document.getElementById("horario");
          for (let i = sel.options.length; i >= 0; i--) {
            sel.remove(i);
          }      
    }



    $('#consultar_horarios_citas').click(function(){
        var datos_consulta = {
            cda: $('#datos_js').attr('cda'),
            referencia_servicio: $('#referencia_id').val(),
            fecha: $("#fecha_cita").val()
        }
        disponibilidad = false
        $.ajax({
            url: "/consultar_disponibilidad_citas",
            type: "get",
            data: datos_consulta,
            success: function(result, xhr){
                limpiar_select_horario()
                var valores = result["disponibilidad"]
                $('#token_consulta').val(result['token_consulta'])
                if (valores.length > 0){
                    disponibilidad = true 
                    var select = document.getElementsByName("horario")[0];
                    for (var value in valores) {
                      var option = document.createElement("option");
                      option.text = valores[value];
                      select.add(option);
                      $('#horario').change()
                    }
                } else {
                    alert("No Existe disponibilidad para: " + $("#fecha_cita").val())
                }
                

            }, error: function(xhr, error){
                alert("Error: valide la fecha y la revisión para consultar");
            }
        });

    })


    $('#horario').change(function(){
        if (disponibilidad){
            $('#fechayhora').val($("#fecha_cita").val() + " " + $('#horario').val())
        }
    })



    $( "#fecha_cita" ).datepicker({
        minDate: new Date(),
        maxDate: "+2M",
        onSelect: function() {
            limpiar_select_horario()
            $('#fechayhora').val("")
            $('#horario').val("")
        }
    });

    $(document).on('keyup', '#placa', function(){
        $('#placa').val($('#placa').val().toUpperCase())
    })


    $('#referencia_id').change(function(){
        var sel = document.getElementById("horario");
         for (let i = sel.options.length; i >= 0; i--) {
            sel.remove(i);
        }
        $('#fechayhora').val("")
    });


    $('#acepto').change(function () {
        $('#boton_agendar').prop('disabled', !$(this).prop('checked'))
    })

    $("#telefono_celular").change(function(){
        var valor_telefono = $("#telefono_celular").val()
        if (valor_telefono >= 3000000000 && valor_telefono <= 3999999999){
            $('.acepto_sms').removeClass('hidden')
            console.log("se activa el check")
            document.getElementById("acepto_sms").checked = true
            console.log("se activa el check")

        }else{
            $('.acepto_sms').addClass('hidden')
            console.log("se desactiva el check")
            document.getElementById("acepto_sms").checked = false
            console.log("se desactiva el check")
        
        }
    })

    $('#email').change(function(){
        $('#email').val($('#email').val().replaceAll(' ',''))
    })
    
    $("#boton_agendar").click(function(e){

        if ($('#nombresyapellidos').val().length <= 1){
            alert("Ingrese su nombre")
            e.preventDefault()
            return
        }

        if (!correoRegex.test($('#email').val().replaceAll(' ',''))) {
          alert("El correo electrónico no tiene un formato valido")
          e.preventDefault()
          return
        }
        

        if ($('#telefono_celular').val() == "" || $('#telefono_celular').val() == null){
          var bool = confirm("Diligencie por favor el número de celular");
          if(bool){
            console.log("no se enviara sms");
          }else{
            console.log("cancelo la solicitud");
            e.preventDefault()
            return
          }        
        }

        if ($('#telefono_celular').val().length != 7 && $('#telefono_celular').val().length != 10 && $('#telefono_celular').val() != "" ){
            alert("El número de télefono debe tener 7 o 10 caracteres")
            e.preventDefault()
            return
        }


        if (!/^[A-Z0-9]{5,10}$/.test($('#placa').val())){
            alert("Ingrese una placa válida")
            e.preventDefault()
            return
        }


        if ($('#fechayhora').val() == "" || $('#fechayhora').val().length == null){
            alert("fecha y hora de la cita no seleccionada")
            e.preventDefault()
            return   
        }

    })

})